import styled from 'styled-components';

export const TripHotelDetailMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        border-radius: .6rem;
        box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
        margin-bottom: ${props.theme.spacing.large.l15};
        padding: ${props.theme.spacing.large.l25} 0;
    `
);


export const TripHotelDetailHeaderWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;
        border-left: 5px solid ${props.theme.colors.grey.base1};
        padding: 0 ${props.theme.spacing.large.l25} 0 ${props.theme.spacing.large.l20};
    `
);

export const TripHotelHeaderText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        padding-bottom: ${props.theme.spacing.small.s5};
    `
);

export const TripHotelHeaderSubText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const TripHotelAmenitiesWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l25} 0; 
    `
);

export const TripHotelInfoWrap = styled.ul(
    props => `
    width:100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l25} 0  ${props.theme.spacing.large.l45}; 
    flex-direction: column;

    li{
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        padding: ${props.theme.spacing.small.s5};
        line-height: 1.2;
    }
    `
)

export const TripHotelAmenitiesInnerWrap = styled.div(
    props => `
        display: flex;
        width:60%;
        flex-direction: column;
    `
);

export const HotelAmenitiesWrap = styled.div(
    props => `
        display: flex;
        flex-flow: wrap;
        align-items: center;
    `
);

export const HotelAmenitiesList = styled.ul(
    props => `
        width:100%;
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        padding-right: ${props.theme.spacing.large.l20};
        list-style-position: inside;

        li{
            width:33%;
            padding-bottom: ${props.theme.spacing.large.l15};
            font-size: ${props.theme.font.large.font13};
            color: ${props.theme.colors.grey.base};
        }
    `
)

export const HotelShowAllAmenitiesWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top: ${props.theme.spacing.large.l15};
    `
);

export const ShowAllAmenitesText = styled.a(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;

        &:hover{
            color: ${props.theme.colors.blue.base};
        }
    `
);

export const TripHotelImagesWrap = styled.div(
    props => `
        width:40%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    `
);


export const HotelImageTrip = styled.img(
    props => `
        width:10rem;
        height: 10rem;
        border-radius: ${props.theme.misc.borderRadius.base};
    `
);

export const MoreHotelImageTrip = styled.div(
    props => `
        width:10rem;
        height: 10rem;
        border-radius: ${props.theme.misc.borderRadius.base};
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props.theme.colors.blue.base};
    `
);

export const MoreImgText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        cursor: pointer;

        span{
            font-size: ${props.theme.font.base};
            font-weight: normal;
        }
    `
);